export const EDIT_STOCK = '@productStock/editStock';

export function editStock(payload) {
  return {
    type: EDIT_STOCK,
    payload,
  };
}
